import { List } from "immutable";
import { createSelector } from "reselect";

import {
  getAllContentModules,
  modulesSelectors
} from "seneca-common/features/course/state";
import {
  getSectionStats,
  sectionStatsSelectors
} from "seneca-common/features/stats/state";

const emptyList = List([]);

export default function makeGetIncorrectContentModules(sectionId: string) {
  return createSelector(
    getAllContentModules,
    getSectionStats,
    (contentModules, sectionStats) => {
      const incorrectModuleIds =
        sectionStatsSelectors.getModuleIdsIncorrectLast(
          sectionStats as any,
          sectionId
        );

      // If the user hasn't studied the section before return nothing
      if (!incorrectModuleIds) {
        return emptyList;
      }

      return modulesSelectors.listExistingContentModules(
        contentModules,
        incorrectModuleIds
      );
    }
  );
}
